// extracted by css-extract-rspack-plugin
export default {"Box":"SubIssueRemovedEvent-module__Box__PZnkG","Box_1":"SubIssueRemovedEvent-module__Box_1__VvH36"};